import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Notifications from 'vue-notification'
import BootstrapVue from 'bootstrap-vue'
import { BootstrapVueIcons } from 'bootstrap-vue'
import * as VueWindow from '@hscmap/vue-window'
import VueSimpleAlert from 'vue-simple-alert'
import VueMeta from 'vue-meta'
import './assets/styles/custom.scss'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import notificationTerm from '@/functions/notificationTerminal.js'
import './firebaseConfig';
import './index.css'

Vue.use(BootstrapVueIcons)
Vue.use(VueWindow)
Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.use(VueSimpleAlert);
Vue.use(VueMeta);
Vue.config.productionTip = false

Vue.prototype.$notifTerm = notificationTerm

let app;
const auth = getAuth();
const mountApp = () => {
    if (!app) {
        /* eslint-disable no-new */
        app = new Vue({
            store,
            router,
            render: h => h(App)
        }).$mount('#app');
    }
};
onAuthStateChanged(auth, mountApp);
setTimeout(mountApp, 3000);